import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { NgxInnerLoadingModule } from 'ngx-inner-loading';

import { PeriodBarModule } from '../../../../../../../components/period-bar/period-bar.module';
import { CreditRowModule } from '../../../../components/credit-row/credit-row.module';
import { CreditsComponent } from './credits.component';

@NgModule({
  declarations: [CreditsComponent],
  imports: [
    CommonModule,
    CreditRowModule,
    InfiniteScrollModule,
    NgxInnerLoadingModule,
    PeriodBarModule,
  ],
})
export class CreditsModule {}
